import { createContext } from 'react'

import ApiCallStore from 'stores/ApiCallStore'

const ApiCallStoreContext = createContext<ApiCallStore>(new ApiCallStore())

export default ApiCallStoreContext
